import Vue from 'vue'
import Vuex from 'vuex'
import { slugToRegion, slugToDimension, dimensionToSlug, slugToLanguage } from '@/utils/helpers'
import { slugToIso } from '@/utils/countryMap'
import getters from '@/store/modules/getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    dimension: 'forestCover',
    region: 'amazonas',
    regionSlug: 'amazonas',
    dimensionSlug: 'skogdekke',
    country: null,
    language: 'no'
  },
  /**
   * getters
   */
  getters: getters,

  mutations: {
    dimension(state, _dimension) {
      state.dimension = slugToDimension(_dimension)
      state.dimensionSlug = dimensionToSlug(state.dimension, state.language)
    },
    region(state, slug) {
      state.regionSlug = slug
      state.region = slugToRegion(slug)
    },
    country(state, slug) {
      if (slug) {
        state.country = slugToIso(slug, state.language)
      } else {
        state.country = null
      }
    },
    language(state, _dimension) {
      if (_dimension) {
        state.language = slugToLanguage(_dimension)
      }
      document.title = state.language === 'en' ? 'State of the rainforest' : 'Regnskogens tilstand'
    }
  }
})

export default store
